import { Allergens } from '../../../../../enums/FoodieIcons';
import NotInformation from '../../../../../components/NotInformation';
import { useTranslation } from 'react-i18next';
import CustomUserChip from './../../../../../components/CustomUserChip';
import CustomGenericTittleIconDataChip from '../../../../../components/CustomGenericTittleIconDataChip';
import { IconIngredient } from '../../../../../components/buttons/IconButtons';
import {getUnitTransByName} from "../../Ingredients/Model/Models";
import CustomMediumChip from '../../../../../components/CustomMediumChip';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const DishListDetails = ({ item }) => {
    const { t } = useTranslation();

    return (
        <>
            <CustomGenericTittleIconDataChip Icon={IconIngredient} title='ingredients' key='ingredients-section' />
            <div className='d-flex flex-wrap gap-3 mb-3'>
                {item.row.ingredients?.length > 0 ? (
                    <div className='d-flex flex-wrap gap-3 justify-content-start mt-3'>
                        {item.row.ingredients.map(({ ingredientId, ingredientName, quantity, unit }) => (
                            <CustomMediumChip key={ingredientId} title={ingredientName}>
                                    {quantity} {t(getUnitTransByName(unit))}(s)
                            </CustomMediumChip>
                        ))}
                    </div>
                ) : (
                    <NotInformation text={t('no_information')} card={false} />
                )}
            </div>
            <CustomGenericTittleIconDataChip
                className='mt-5'
                Icon={IconIngredient}
                title='allergens'
                key='allergens-section'
            />
            <div className='d-flex flex-wrap gap-3'>
                {item.row.allergenIds?.length > 0 ? (
                    <div className='d-flex flex-wrap gap-3 justify-content-start'>
                        {item.row.allergenIds.map((id) => {
                            const allergen = Allergens[id];
                            if (!allergen) return null;

                            const { icon: Icon, name } = allergen;
                            const translatedName = t(name);

                            return <CustomUserChip key={id} name={translatedName} Icon={Icon} showAvatar={true} />;
                        })}
                    </div>
                ) : (
                    <NotInformation text={t('no_information')} card={false} />
                )}
            </div>
        </>
    );
};

export default DishListDetails;
